import { createContext, useState } from 'react';

type UserPictureContextType = {
  loggedInUserPictureUrl: string | null;
  setLoggedInUserPictureUrl: (url: string | null) => void;
};

interface UserPictureProviderProps {
  children: React.ReactNode;
}

export const UserPictureContext = createContext<UserPictureContextType>({
  loggedInUserPictureUrl: '',
  setLoggedInUserPictureUrl: () => {},
});

export const UserPictureProvider = ({ children }: UserPictureProviderProps) => {
  const [loggedInUserPictureUrl, setLoggedInUserPictureUrl] = useState<
    string | null
  >(null);

  return (
    <UserPictureContext.Provider
      value={{
        loggedInUserPictureUrl,
        setLoggedInUserPictureUrl,
      }}
    >
      {children}
    </UserPictureContext.Provider>
  );
};
